import React, { SyntheticEvent } from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  FlexDirection,
  FontFamily,
  Image as CitrusImage,
  JustifyContent,
  Overflow,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import { onSpaceOrEnter } from '../../utils/accessibility'
import { getDefaultImage, getSrcSet } from '../../utils/formatters'
import { RecipeImage } from '@library/menu-service'

const CenteredImage = withCitrusTheme(CitrusImage, () => ({
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '3px',
}))

const ClickableBox = withCitrusTheme(Box, () => ({ cursor: 'pointer' }))

type RecipeProps = {
  name: string
  image: RecipeImage['crops']
  onClick: (e: SyntheticEvent) => void
  portionLabel?: string | null
}

export const RecipeClickableImage = ({ image, onClick, name, portionLabel }: RecipeProps) => (
  <ClickableBox
    alignItems={AlignItems.Center}
    bg={Color.NeutralGrey_50}
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    height={['62px', '50px']}
    justifyContent={JustifyContent.SpaceBetween}
    overflowX={Overflow.Hidden}
    overflowY={Overflow.Hidden}
    position={DisplayPosition.Relative}
    role="button"
    tabIndex={0}
    width="100%"
    onClick={onClick}
    onKeyDown={onSpaceOrEnter(onClick)}
    maxWidth={['71px', '62px']}
  >
    <CenteredImage
      alt={name}
      loading="lazy"
      src={getDefaultImage(image)}
      srcSet={getSrcSet(image)}
    />
    {portionLabel && (
      <Box
        data-testid="recipe-portion-label"
        height="18px"
        width="100%"
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          boxSizing: 'border-box',
          padding: '0 4px',
        }}
      >
        <Text
          color={Color.ColdGrey_800}
          fontFamily={FontFamily.Bold}
          style={{
            fontSize: '10px',
            lineHeight: '12px',
            whiteSpace: 'nowrap',
            textAlign: 'center',
          }}
        >
          {portionLabel}
        </Text>
      </Box>
    )}
  </ClickableBox>
)
